import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC } from "react";
import { GetAllServicesSummary } from "src/apis/services";
import { formatDateToBR } from "src/utils/date";

type AllServicesSummaryProps = {
  startDate: string;
  endDate: string;
  summary: GetAllServicesSummary|null;
}

const AllServicesSummary: FC<AllServicesSummaryProps> = ({startDate, endDate, summary}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableCell colSpan={2}><strong>Resumo de atendimentos, período de {formatDateToBR(startDate)} até {formatDateToBR(endDate)}</strong></TableCell>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell><strong>Atendimentos</strong></TableCell>
            <TableCell>{summary?.qtde_atendimentos}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Psicólogos que atenderam nesse período</strong></TableCell>
            <TableCell>
              {summary?.psicologos?.map((name) => (
                <p>{name}</p>
              ))}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Colaboradores atendidos nesse período</strong></TableCell>
            <TableCell>
              {summary?.colaboradores_atendidos?.map((name) => (
                <p>{name}</p>
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default AllServicesSummary;
